import {
  ADMIN_TOKEN_NAME,
  STORE_USER,
  SET_USERS,
  SELECT_USER,
  SET_SEEDS,
  SELECT_SEED,
  SET_WHITELIST,
  SELECT_WHITELIST,
  ADMIN_ERROR,
  ADMIN_LOADING,
  SET_MBID_LOOKUP,
  SET_PREFERENCE_LOOKUP,
  SET_UNIQUEID_LOOKUP,
  SET_SPAMCHECK,
} from "../constants";

const initial_state = {
  loading: {
    users: false,
    approvers: false,
    seedLists: false,
    whitelist: false,
    mbIdLookUpResult: false,
    preferenceLookUpResult: false,
    uniqueIdLookUpResult: false,
    spamCheckResult: false,
  },
  errors: {},

  // Users
  users: [], // List of available users
  selectedUser: {}, // Selected User
  token: localStorage.getItem(ADMIN_TOKEN_NAME) || "", // THIS admin token - stored for impersonation

  // Seeds
  seedLists: [],
  selectedSeed: {},

  // Whitelist
  whitelist: [],
  selectedWhitelist: {},
  whitelistInternal: false,

  // mbIdLookUp: An object with 5 array properties
  mbIdLookUpResult: {},
  //Account Preference LookUp
  preferenceLookUpResult: [],
  uniqueIdLookUpResult: [],
  spamCheckResult: [],
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case ADMIN_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case ADMIN_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case STORE_USER:
      if (!localStorage.getItem(ADMIN_TOKEN_NAME)) {
        localStorage.setItem(ADMIN_TOKEN_NAME, payload.token);

        return {
          ...state,
          ...payload,
        };
      }

      return state;

    case SET_USERS:
      loading.users = false;

      return {
        ...state,
        loading,
        users: payload,
      };

    case SELECT_USER:
      return {
        ...state,
        selectedUser: payload,
      };

    case SET_SEEDS:
      loading.seedLists = false;
      return {
        ...state,
        loading,
        seedLists: payload,
      };

    case SELECT_SEED:
      return {
        ...state,
        selectedSeed: payload,
      };

    case SET_WHITELIST:
      loading.whitelist = false;
      return {
        ...state,
        loading,
        whitelist: payload.whitelist,
        whitelistInternal: payload.internal_user,
      };

    case SELECT_WHITELIST:
      return {
        ...state,
        selectedWhitelist: payload,
      };

    case SET_UNIQUEID_LOOKUP:
      loading.uniqueIdLookUpResult = false;
      return {
        ...state,
        loading,
        uniqueIdLookUpResult: payload,
      };
    case SET_MBID_LOOKUP:
      loading.mbIdLookUpResult = false;
      return {
        ...state,
        loading,
        mbIdLookUpResult: payload,
      };

    case SET_PREFERENCE_LOOKUP:
      loading.preferenceLookUpResult = false;
      return {
        ...state,
        loading,
        preferenceLookUpResult: payload,
      };

    case SET_SPAMCHECK:
      loading.spamCheckResult = false;
      const singleRecordArr = payload && payload.length > 0 ? [payload[0]] : [];
      return {
        ...state,
        loading,
        spamCheckResult: singleRecordArr,
      };

    default:
      return state;
  }
}
